import formatDate from './datetime'
import capitalize from './capitalize'

export default {
  install(Vue) {
    Vue.filter('formatDate', formatDate)
    Vue.filter('capitalize1', capitalize)
  }
}
